// authService.js
import { Login } from "../api/Auth/auth";
// import rolesData from "./roles.json";
import CryptoJS from "crypto-js";
const SECRET_KEY = "1234pallaveceFSDwd";

export const login = async (username, password) => {
  const encypted_password = encryptPassword(password);
  const payload = {
    username,
    password: encypted_password,
  };
  const response = await Login(payload);
  console.log("********* response *****************");
  console.log(response);

  if (response) {
    localStorage.setItem("user", JSON.stringify(response.user));
    localStorage.setItem("token", response.token);
    return response;
  }
  return null;
};

export const getCurrentUser = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user;
};

export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
};

export const hasPermission = (permission) => {
  const user = getCurrentUser();
  if (!user) return false;

  const permissions = user.permissions;

  if (!permissions) return false;

  // const permissions = rolesData.permissions[user.role] || [];
  // console.log(
  //   "permissions.includes(permission): ",
  //   permissions.includes(permission)
  // );
  return permissions.includes(permission);
};

export const encryptPassword = (password) => {
  return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
};

export const decryptPassword = (password) => {
  const bytes = CryptoJS.AES.decrypt(password, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
